"use client"

import { useState } from "react"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import PlanSection from "../components/PlanSection"
import PaymentMethodsSection from "../components/PaymentMethodsSection"
import BillingHistorySection from "../components/BillingHistorySection"

import "bootstrap/dist/css/bootstrap.min.css"
import { useStore } from "../store";


export default function BillingPage() {
    const { auth, setAuth } = useStore();

    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY as string)
  const [activeTab, setActiveTab] = useState("plan")

  const renderTabContent = () => {
    switch (activeTab) {
      case "plan":
        return (
          <Elements stripe={stripePromise}>
            <PlanSection />
          </Elements>
        )
      case "paymentMethods":
        return <PaymentMethodsSection />
      case "billingHistory":
        return <BillingHistorySection />
      default:
        return null
    }
  }

  return (
    <div className="container mt-5">
      <h1 className="mb-4">Billing</h1>
      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "plan" ? "active" : ""}`}
            href="#"
            onClick={(e) => {
              e.preventDefault()
              setActiveTab("plan")
            }}
          >
            Plan
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "paymentMethods" ? "active" : ""}`}
            href="#"
            onClick={(e) => {
              e.preventDefault()
              setActiveTab("paymentMethods")
            }}
          >
            Payment Methods
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "billingHistory" ? "active" : ""}`}
            href="#"
            onClick={(e) => {
              e.preventDefault()
              setActiveTab("billingHistory")
            }}
          >
            Billing History
          </a>
        </li>
      </ul>
      <div className="tab-content">{renderTabContent()}</div>
    </div>
  )
}

